import { isPlatformBrowser, ViewportScroller } from '@angular/common';
import { Component, Inject, NgZone, OnInit, PLATFORM_ID, Renderer2 } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { timer } from 'rxjs';
import { filter, first } from 'rxjs/operators';
import { CookieComponent } from './shared/components/cookie/cookie.component';
import { AnalyticsService } from './shared/services/analytics.service.';
import { CartService } from './shared/services/cart.service';
import { CompareService } from './shared/services/compare.service';
import { CurrencyService } from './shared/services/currency.service';
import { CategoriaAttualeService } from './shared/services/custom/categoria-attuale.service';
import { PriceArticoloService } from './shared/services/custom/price-articolo.service';
import { MyTidyConfigService } from './shared/services/my-tidy-config.service';
import { StoreService } from './shared/services/store.service';
import { WishlistService } from './shared/services/wishlist.service';
import { TranslateService } from '@ngx-translate/core';
import { ServizioMenuService } from './shared/services/servizio-menu.service';

const COOKIE_KEY = 'cookie_accepted';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    cookie_settings;

    constructor(
        @Inject(PLATFORM_ID) private platformId: any,
        private router: Router,
        private toastr: ToastrService,
        private cart: CartService,
        private compare: CompareService,
        private wishlist: WishlistService,
        private zone: NgZone,
        private scroller: ViewportScroller,
        private currency: CurrencyService,
        private store: StoreService,
        private title: Title,
        private meta: Meta,
        private renderer2: Renderer2,
        private categoriaService: CategoriaAttualeService,
        private modalService: BsModalService,
        private analytics: AnalyticsService,
        private config : MyTidyConfigService,
        private translate: TranslateService,
        private menuService: ServizioMenuService
    ) {
        this.analytics.mtViewAzienda();
        try {
            this.cookie_settings = JSON.parse(localStorage.getItem(COOKIE_KEY));
            if (this.cookie_settings)
                this.onSetCookieConsent();
        }
        catch (err) {}

        this.title.setTitle(this.store.name);
        this.meta.updateTag({
            'name': 'og:site_name',
            'content': this.store.name
        });

        var link = document.createElement('link');
        link.type = 'image/x-icon';
        link.rel = 'icon';
        link.href = this.store.logo;
        document.getElementsByTagName('head')[0].appendChild(link);


        this.router.initialNavigation();

        if (isPlatformBrowser(this.platformId)) {
            this.zone.runOutsideAngular(() => {
                this.router.events.pipe(filter(event => event instanceof NavigationEnd), first()).subscribe(() => {
                    this.config.nextConfig$.next(null);
                    const preloader = document.querySelector('#preloading-wrapper');
                    preloader.remove();
                });
            });
        }
    }

    ngOnInit(): void {
        const s = this.renderer2.createElement('script');
        s.type = 'text/javascript';
        s.src = 'https://js.stripe.com/v3/';
        s.text = ``;
        this.renderer2.appendChild(document.body, s);

         this.menuService.getFamiglie();

        // properties of the CurrencyFormatOptions interface fully complies
        // with the arguments of the built-in pipe "currency"
        // https://angular.io/api/common/CurrencyPipe
        this.currency.options = {
            code: 'EUR',
            // display: 'symbol',
            // digitsInfo: '1.2-2',
            // locale: 'en-US'
        };

        this.router.events.subscribe((event) => {
            if ((event instanceof NavigationEnd)) {
                this.scroller.scrollToPosition([0, 0]);

                timer(0).subscribe(() => {
                    this.analytics.onPageView(event.urlAfterRedirects);
                });

            }
        });
        this.cart.onAdding$.subscribe(item => {
        const message = this.translate.instant('PRODUCT.ITEM_ADDED', { name: item.product.descart });
        this.toastr.success(message);
        this.analytics.onAddToCart(item);
        });

        this.compare.onAdding$.subscribe(product => {
            this.toastr.success(`Product "${product.name}" aggiunto al confronto!`);
        });
        this.wishlist.onAdding$.subscribe(product => {
            this.analytics.onAddToWishlist(product);
            this.toastr.success(`Articolo "${product.descart}" aggiunto ai preferiti!`);
        });
    }

    acceptAllCookie() {
        this.cookie_settings = {
            'facebook_pixel': true,
            'google_analytics': true,
            'facebook_live_chat': true
        };

        localStorage.setItem(COOKIE_KEY, JSON.stringify(this.cookie_settings));

        this.onSetCookieConsent();
    }

    loadFacebookLiveChat() {
        if (this.store.facebook_chat_id) {
            document.body.insertAdjacentHTML('beforeend', `<div class="fb-customerchat"
                attribution="biz_inbox"
                page_id="${this.store.facebook_chat_id}"></div>`);

            // @ts-ignore
            window.fbAsyncInit = function() {
                // @ts-ignore
                FB.init({
                    xfbml            : true,
                    version          : 'v10.0'
                });
            };
    
            (function(d, s, id) {
                var js, fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) return;
                js = d.createElement(s); js.id = id;
                js.src = 'https://connect.facebook.net/it_IT/sdk/xfbml.customerchat.js';
                fjs.parentNode.insertBefore(js, fjs);
            }(document, 'script', 'facebook-jssdk'));

            // // @ts-ignore
            // FB.XFBML.parse();
        }
    }

    onSetCookieConsent() {
        if (this.cookie_settings.google_analytics) {
            this.analytics.loadGoogleAnalytics(this.store.UA_ID);
        }

        if (this.cookie_settings.facebook_pixel) {
            this.analytics.loadFacebookPixel(this.store.FACEBOOK_PIXEL);
        }

        if (this.cookie_settings.facebook_live_chat) {
            this.loadFacebookLiveChat();
        }
    }

    bsCoockieModalRef: BsModalRef;
    openCookieComponent() {
        this.bsCoockieModalRef = this.modalService.show(CookieComponent, {ignoreBackdropClick: true, class: 'modal-xl'});
        this.bsCoockieModalRef.onHide.subscribe(() => {
            if (this.bsCoockieModalRef.content.saveClicked) {
                this.cookie_settings = this.bsCoockieModalRef.content.form.value;
                this.onSetCookieConsent();
            }
        });
    }

}
